var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "claimsNav" },
    [
      _c("nav", { staticClass: "navbar" }, [
        _c("div", { staticClass: "nav-left flex" }, [
          _c("button", {
            staticClass: "btn btn-back nav-back",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                _vm.$router.push("/claims")
              }
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "nav-item flex flex-column" },
            [
              _vm.claimById
                ? _c("simple-select", {
                    staticClass: "claim-type-name",
                    attrs: {
                      options: _vm.claimTypes,
                      "track-by": "id",
                      placeholder: _vm.claimById.claim_type.name
                    },
                    on: { input: _vm.claimUpdateType },
                    model: {
                      value: _vm.claim.claim_type_id,
                      callback: function($$v) {
                        _vm.$set(_vm.claim, "claim_type_id", $$v)
                      },
                      expression: "claim.claim_type_id"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.claimById
                ? _c(
                    "span",
                    {
                      staticClass: "list-box-status d-flex align-items-start",
                      class: _vm.claimStatus
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.claimById.claim_status.name) +
                          "\n        "
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "nav-item icon" }, [
            _c("i", {
              staticClass: "fa fa-exclamation-circle",
              class: _vm.claimPriority,
              staticStyle: { "font-size": "16px", "padding-right": "6px" }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "nav-item select-prio" },
            [
              _vm.claimById
                ? _c("simple-select", {
                    staticClass: "nav-select",
                    class: _vm.claimPriority,
                    attrs: {
                      options: _vm.claimPriorities,
                      "track-by": "id",
                      placeholder: _vm.claimById.claim_priority.name
                    },
                    on: { input: _vm.claimUpdatePriority },
                    model: {
                      value: _vm.claim.claim_priority_id,
                      callback: function($$v) {
                        _vm.$set(_vm.claim, "claim_priority_id", $$v)
                      },
                      expression: "claim.claim_priority_id"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "nav-right flex" }, [
          _vm.claimById.job &&
          _vm.claimById.job.company &&
          _vm.$_can("tags.show")
            ? _c(
                "div",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-end flex-wrap mr-3"
                },
                _vm._l(_vm.claimById.job.company.tags, function(tag) {
                  return _c("tag-color", {
                    key: tag.id,
                    attrs: {
                      color: tag.color.name,
                      name: tag.name,
                      "input-class": "mr-3"
                    }
                  })
                })
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-secondary nav-item",
              attrs: { type: "button" },
              on: { click: _vm.toggleRefundModal }
            },
            [_c("i", { staticClass: "fa fa-usd" }), _vm._v(" Refund")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary nav-item",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  _vm.claimClose = true
                }
              }
            },
            [_vm._v("Close claim")]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.claimClose
        ? _c(
            "modal",
            {
              attrs: { size: "modal-large", "close-strict": true },
              on: {
                close: function($event) {
                  _vm.claimClose = false
                }
              }
            },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("h4", [_vm._v("Close claim")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "body" }, slot: "body" },
                [
                  _c(
                    "div",
                    { staticClass: "select-wrap" },
                    [
                      _c("label", [_vm._v("Select a resolution")]),
                      _vm._v(" "),
                      _vm.claimById
                        ? _c("simple-select", {
                            attrs: { options: _vm.claimResolutions },
                            model: {
                              value: _vm.claim_resolution_id,
                              callback: function($$v) {
                                _vm.claim_resolution_id = $$v
                              },
                              expression: "claim_resolution_id"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "claim_resolution_id" }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "select-wrap h-auto mt-3" }, [
                    _c("label", [_vm._v("Enter a note")]),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.note,
                          expression: "note"
                        }
                      ],
                      staticClass: "select-wrap-textarea form-control",
                      attrs: { rows: "5", required: "" },
                      domProps: { value: _vm.note },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.note = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "note" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 text-right" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.claimClose = false
                          }
                        }
                      },
                      [_vm._v("Cancel")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "button", disabled: _vm.buttonDisabled },
                        on: { click: _vm.claimResolution }
                      },
                      [_vm._v("Close claim")]
                    )
                  ])
                ])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.showRefundModal
          ? _c(
              "div",
              { staticClass: "l-modal-mask" },
              [
                _c("transactions-modal", {
                  staticClass: "sidebar-right",
                  attrs: { claim: _vm.claimById },
                  on: {
                    cancel: function($event) {
                      _vm.toggleRefundModal()
                    },
                    update: function($event) {
                      _vm.$emit("update")
                    }
                  }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e3a10f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e3a10f0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/claims/LayoutTopNav.vue
// module id = null
// module chunks = 